import { render, staticRenderFns } from "./CommentsListWrap.vue?vue&type=template&id=9ce59538&"
import script from "./CommentsListWrap.vue?vue&type=script&lang=js&"
export * from "./CommentsListWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports